/* eslint-disable */
import moment from 'moment';
/**
 * Gets user type from billTo
 * @param {string} billTo in format 1234:type where type can be super or standard
 * @returns {string} returned type, super or standard
 */
const getUserTypeFromBillTo = (billTo) => billTo ? billTo.replace(/^.*:/, ``) : `standard`;

/**
 * Gets number from billTo
 * @param {string} billTo in format 1234:type where type can be super or standard
 * @returns {string} returned type, super or standard
 */
const getNumberFromBillTo = (billTo) => (typeof billTo === `string` ? billTo.replace(/:.*$/, ``) : ``);

/**
 * Returns last loggedin string
 * @param {string} lastLogin date string
 * @returns {string} returned Last loggedin string
 */
const lastLoggedIn = (lastLogin) => {
  let lastLoggedInMessage = ``;
  if (lastLogin) {
    const daysAgo = moment().diff(lastLogin, `days`);
    if (daysAgo > 1) {
      lastLoggedInMessage = `Last login: ${daysAgo} days ago`;
    } else if (daysAgo === 0) {
      lastLoggedInMessage = `Last login: less than a day ago`;
    } else if (daysAgo === 1) {
      lastLoggedInMessage = `Last login: 1 day ago`;
    }
  } else {
    lastLoggedInMessage = `Never logged in`;
  }
  return lastLoggedInMessage;
};

/**
 * getErrorMessage
 * @param {string} errorCode in format 1234:type where type can be super or standard
 * @returns {string} Returns plain english error message
 */
const getErrorMessage = (errorCode) => {
  switch (errorCode) {
    case `USER_EXISTS_AS_SUPER_USER`: {
      return `User already assigned to account as a Super User`;
    }
    case `USER_EXISTS_AS_STANDARD_USER`: {
      return `User already assigned to account as a Standard User`;
    }
    default:
      return `An error has occurred. Please try again later.`;
  }
};

export default {
  getErrorMessage,
  getNumberFromBillTo,
  getUserTypeFromBillTo,
  lastLoggedIn,
};
